export default "__VITE_ASSET__BG$Uve4t__"